export const MILLISECONDS = {
  second: 1000,
  minute: 60000,
  hour: 3600000,
  day: 3600000 * 24,
};
